/**
 * @module system
 * @description System info, health check, OpenAPI spec
 */

import type { ModuleManifest } from '@gzl10/nexus-sdk'
import { createSystemRoutes } from './system.routes.js'
import { moduleEntity, osEntity } from './system.entity.js'
import { migrationHistoryEntity } from './migration-history.entity.js'
import { envConfigEntity } from './env-config.entity.js'
import { getEnvVarRegistry, registerCoreVars } from './env-config.registry.js'
import { factoryResetAction } from './actions/factory-reset.action.js'
import { restartServerAction } from './actions/restart-server.action.js'

// Re-exports
export { createSystemController } from './system.controller.js'
export { moduleEntity, osEntity } from './system.entity.js'
export { migrationHistoryEntity } from './migration-history.entity.js'
export { envConfigEntity } from './env-config.entity.js'
export { getEnvVarRegistry } from './env-config.registry.js'
export type { EnvVarEntry } from './env-config.registry.js'
export type {
  OsComputedDTO
} from './system.types.js'

export const systemModule: ModuleManifest = {
  name: 'system',
  label: { en: 'System', es: 'Sistema' },
  icon: 'mdi:cog-outline',
  description: { en: 'System configuration, module registry, and platform metadata', es: 'Configuración del sistema, registro de módulos y metadatos de plataforma' },
  type: 'core',
  category: 'settings',
  dependencies: ['logger'],
  definitions: [
    moduleEntity, osEntity, envConfigEntity,
    migrationHistoryEntity
  ],

  actions: [
    restartServerAction,
    factoryResetAction
  ],

  init: (ctx) => {
    const registry = getEnvVarRegistry()
    registerCoreVars(registry)

    // Inject envVars from registered plugins
    for (const plugin of ctx.engine.getPlugins()) {
      if (plugin.envVars?.length) {
        registry.register(plugin.name, plugin.code, plugin.envVars)
      }
    }

    ctx.services.register('envVarRegistry', registry)
  },
  routes: createSystemRoutes,
  routePrefix: '/system'
}
